module.exports = __webpack_public_path__ + "static/media/00773-SE ACTUALIZAN TARIFAS DE LOS DERECHOS DEL EJERCICIO DE LA FUNCION NOTARIAL.80401757.pdf";